import Swiper, { Navigation, Pagination, Scrollbar, Keyboard, Zoom } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation, Pagination, Scrollbar, Keyboard, Zoom]);


$(function () {

    // init Swiper:
    window.swiper = new Swiper('.swiper-container', {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 100,
        loop: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        watchOverflow: true,
        speed: 600,
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
            draggable: true
        },
        updateOnWindowResize: true,
        keyboard: {
            enabled: true,
        },
        // zoom: {
        //     enabled: true,
        // },
    });

});
